import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	FormHelperText,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from '@mui/material';
import axios from 'axios';
import { useState } from 'react';
  
  export default function AddUserForm({ open, onClose }) {
	// State variables for the user form
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [emailAddress, setEmailAddress] = useState('');
	const [password, setPassword] = useState('');
	const [role, setRole] = useState('');
	const [company, setCompany] = useState('');
	const [status, setStatus] = useState('active'); // Default to 'active'
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const [submitted, setSubmitted] = useState(false); // Track if form is submitted
  
	// Handle form submission
	const handleSubmit = async () => {
	  setError('');
	  setSubmitted(true); // Mark the form as submitted
  
	  // Validate form fields
	  if (!firstName || !lastName || !emailAddress || !password || !role || !status || !company) {
		setError('All fields are required.');
		return;
	  }
  
	  // Validate email format
	  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
	  if (!emailRegex.test(emailAddress)) {
		setError('Invalid email address format.');
		return;
	  }
  
	  setLoading(true);
	  try {
		const newUser = {
		  firstName,
		  lastName,
		  emailAddress,
		  password,
		  role,
		  company: company || undefined, // Added company to the user data
		  status,
		};
  
		console.log('Submitting user:', newUser); // Debugging log
  
		const response = await axios.post('/user', newUser); // Adjust the endpoint if necessary
  
		if (response.status === 201) {
		  onClose();
		} else {
		  setError('Failed to add user.');
		}
	  } catch (error) {
		console.error('Error adding user:', error);
		if (error.response) {
		  console.error('Server Response:', error.response.data);
		  setError(error.response.data.message || 'Server error occurred.');
		} else if (error.request) {
		  setError('Network error: Failed to communicate with the server.');
		} else {
		  setError('An unexpected error occurred.');
		}
	  } finally {
		setLoading(false);
	  }
	};
  
	return (
	  <Dialog open={open} onClose={onClose}>
		<DialogTitle>Add New User</DialogTitle>
		<DialogContent>
		  {/* First Name */}
		  <TextField
			label="First Name"
			value={firstName}
			onChange={(e) => setFirstName(e.target.value)}
			fullWidth
			margin="normal"
			error={submitted && !firstName} // Show error after submit
			helperText={submitted && !firstName ? 'This field is required' : ''}
		  />
  
		  {/* Last Name */}
		  <TextField
			label="Last Name"
			value={lastName}
			onChange={(e) => setLastName(e.target.value)}
			fullWidth
			margin="normal"
			error={submitted && !lastName} // Show error after submit
			helperText={submitted && !lastName ? 'This field is required' : ''}
		  />
  
		  {/* Email Address */}
		  <TextField
			label="Email Address"
			type="email"
			value={emailAddress}
			onChange={(e) => setEmailAddress(e.target.value)}
			fullWidth
			margin="normal"
			error={submitted && !emailAddress} // Show error after submit
			helperText={submitted && !emailAddress ? 'This field is required' : ''}
		  />
  
		  {/* Password */}
		  <TextField
			label="Password"
			type="password"
			value={password}
			onChange={(e) => setPassword(e.target.value)}
			fullWidth
			margin="normal"
			error={submitted && !password} // Show error after submit
			helperText={submitted && !password ? 'This field is required' : ''}
		  />
  
		  {/* Company */}
		  <TextField
			label="Company"
			value={company}
			onChange={(e) => setCompany(e.target.value)}
			fullWidth
			margin="normal"
			error={submitted && !company} // Show error after submit
			helperText={submitted && !company ? 'This field is required' : ''}
		  />
  
		  {/* Role Dropdown */}
		  <FormControl fullWidth margin="normal" error={submitted && !role}>
			<InputLabel>Role</InputLabel>
			<Select value={role} onChange={(e) => setRole(e.target.value)} label="Role">
			  <MenuItem value="Admin">Admin</MenuItem>
			  <MenuItem value="User">User</MenuItem>
			  <MenuItem value="Guest">Guest</MenuItem>
			</Select>
			{submitted && !role && <FormHelperText>{'This field is required'}</FormHelperText>}
		  </FormControl>
		</DialogContent>
		<DialogActions>
		  <Button onClick={onClose} disabled={loading}>
			Cancel
		  </Button>
		  <Button onClick={handleSubmit} disabled={loading}>
			{loading ? <CircularProgress size={24} /> : 'Save'}
		  </Button>
		</DialogActions>
	  </Dialog>
	);
  }
  